import { OngoingReportingType } from '@common/interfaces/bbc'
import { IResponse, IFileDownloadResponse } from '@common/interfaces/request'
import { Action } from 'redux'
import { takeEvery, put } from 'redux-saga/effects'
import { download } from '../../helpers/helpers'
import { putPromise } from '../../helpers/redux'
import { calculateOngoingReportingFlags } from '../flag/actions'
import {
  UPDATE_ONGOING_REPORTING_SUCCESS,
  EXPORT_SALES_BY_SKU_VISUALIZATION_SUCCESS,
  EXPORT_SALES_BY_SKU_VISUALIZATION_FAILURE,
  showOngoingReporting,
  listInventoryMapping,
  listSalesBySkuVisualization,
} from './actions'

export function* updateOngoingReportingSuccess() {
  yield takeEvery(
    UPDATE_ONGOING_REPORTING_SUCCESS,
    function* (
      data: IResponse<{
        id: string
        type: OngoingReportingType
        isAssigneeUpdated?: boolean
      }> &
        Action,
    ) {
      yield putPromise(showOngoingReporting(data.data.id))
      if (data.data.type === OngoingReportingType.SalesBySKU) {
        yield putPromise(listInventoryMapping(data.data.id, {}))
        yield putPromise(
          listSalesBySkuVisualization(data.data.id, {
            distribution: 'sku',
          }),
        )
      }
      if (!data.data.isAssigneeUpdated) {
        yield putPromise(calculateOngoingReportingFlags({ id: data.data.id }))
      }
    },
  )
}

export function* exportSalesBySkuVisualization() {
  yield takeEvery(
    EXPORT_SALES_BY_SKU_VISUALIZATION_SUCCESS,
    function* (action: IFileDownloadResponse & Action) {
      try {
        const data = action.data
        const fileName = data.name
        yield download(data, fileName)
      } catch (error) {
        yield put({ type: EXPORT_SALES_BY_SKU_VISUALIZATION_FAILURE, error: error as Error })
      }
    },
  )
}
